import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as Vali from 'helper/validator-helper';
import * as MEnum from './maintenance-enums';

import { Input, TextArea } from 'components/ValidationInput';
import { CheckBoxSingle } from 'components/checkboxes/check-box-single';

import './maintenance.scss';
import MaintenanceServices from './services';

export class GeneralMaintenanceTaskView extends Component {
    static propTypes = {
      dispatch: PropTypes.func,
      history: PropTypes.object,
      projectId: PropTypes.string,
      onCancel: PropTypes.func,
      id: PropTypes.string,
      maintenanceTaskDetail: PropTypes.object
    }

    constructor(props) {
      super(props);

      this.maintenanceService = new MaintenanceServices(this.props.dispatch);
      this.state = {
        activeStep: 1,
        searchText: '',

        name: '',
        description: '',

        selectedLotSet: new Set(),
        applyToAllLot: true
      };
    }

    componentDidMount() {
      this.maintenanceService.getTaskById(this.props.id, this.props.projectId);
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.maintenanceTaskDetail) {
        this.textInputs.name.value = nextProps.maintenanceTaskDetail.name;
        this.textInputs.description.value = nextProps.maintenanceTaskDetail.description;
        this.planSet = this.getLotSet(nextProps.maintenanceTaskDetail.plans);

        let selectedLotSet = nextProps.maintenanceTaskDetail.applyToAllLots
          ? new Set(this.planSet)
          : this.getSelectedLotSet(nextProps.maintenanceTaskDetail.plans);

        this.setState({
          selectedLotSet: selectedLotSet,
          applyToAllLot: nextProps.maintenanceTaskDetail.applyToAllLots
        });
      }
    }

    // manual events
    onTextInputChange = (inputName, obj) => {
      let hasError = false;

      if (!this.textInputs) {
        this.textInputs = {};
      }

      this.textInputs[inputName] = obj;

      for (let key in this.textInputs) {
        if (this.textInputs[key].error) {
          hasError = true;
          break;
        }
      }

      this.setState({ hasError: hasError });
    }

    onClickApplyAllCheckbox = (isChecked) => {
      if (isChecked === true) {
        this.planSet.forEach(element => {
          this.state.selectedLotSet.add(element);
        });

        this.setState({
          applyToAllLot: true,
          selectedLotSet: this.state.selectedLotSet
        });
      }
      else {
        this.state.selectedLotSet.clear();
        this.setState({
          applyToAllLot: false,
          selectedLotSet: this.state.selectedLotSet
        });
      }
    }

    onClickLotCheckbox = (e, value,s) => {
      s.checked ? this.state.selectedLotSet.add(value) : this.state.selectedLotSet.delete(value);

      this.setState({
        selectedLotSet: this.state.selectedLotSet,
        applyToAllLot: this.state.selectedLotSet.size === this.planSet.size
      });
    }

    onClickSaveButton = (e) => {
      e.preventDefault();

      this.maintenanceService.updateTaskById(
        this.props.id,
        this.textInputs.name.value,
        this.textInputs.description.value,
        this.state.applyToAllLot,
        this.state.applyToAllLot ? null : this.state.selectedLotSet,
        this.props.onCancel);
    }

    onChangeSearchTxt = (e) => {
      this.setState(
        { searchText: e.target.value }
      );
    }

    // end manual events

    // helpers
    getSelectedLotSet = (planList) => {
      return planList.reduce((cumPlan, plan) => {
        return plan.lots.reduce((cumLot, lot) => {
          if (lot.checked) {
            cumLot.add(lot.id);
          }

          return cumLot;
        }, cumPlan);
      }, new Set());
    }

    getLotSet = (planList) => {
      return planList.reduce((cumPlan, phase) => {
        return phase.lots.reduce((cumLot, lot) => {
          cumLot.add(lot.id);
          return cumLot;
        }, cumPlan);
      }, new Set());
    }

    // end helpers

    // render
    renderLotList() {
      return (
        <div className='lot-list'>
          {
            this.props.maintenanceTaskDetail.plans.map((plan, index) => {
              let visibleLots = plan.lots
                .map(e => {
                  return {
                    id: e.id,
                    label: `${e.name}, 
                    ${e.streetAddress}`
                  };
                })
                .filter(e => e.label
                  .toLowerCase()
                  .includes(this.state.searchText.toLowerCase())
                );

              if (visibleLots.length === 0) { return null; }

              return (
                <div className='plan-item' key={index}>
                  <div className='plan-name'>{plan.name}</div>
                  <ul>
                    {
                      visibleLots.map(e => {
                        return (
                          <li key={e.id}>
                            <CheckBoxSingle
                              value={e.id}
                              label={e.label}
                              onChecked={this.onClickLotCheckbox}
                              checked={this.state.selectedLotSet.has(e.id)}
                              className='checkbox-default ckb-lot-pick'
                            />
                          </li>
                        );
                      })
                    }
                  </ul>
                </div>
              );
            })
          }
        </div>
      );
    }

    renderRepeatInfo(taskDetail) {
      if (taskDetail.recurringType !== 0) { return null; }

      return (
        <React.Fragment>
          <div className='row' style={{marginTop: '10px'}}>
            <div className='col-md-12'>
              {`Remind ${MEnum.REPEAT_PERIOD_LIST[taskDetail.repeatType].description} ${MEnum.REPEAT_END_LIST[taskDetail.repeatTypeEnd].description} ${MEnum.REPEAT_START_LIST[taskDetail.repeatTypeStart].description}.`}
            </div>
          </div>
        </React.Fragment>);
    }

    render() {
      return (
        <React.Fragment>
          <div className='step-wrapper'>
            <div className='step'>
              <div
                className={`step-number ${this.state.activeStep === 1 ? 'active' : ''}`}
                onClick={() => this.setState({activeStep: 1})}>1</div>
              <span className='step-header'>Name & Recurring pattern</span>
            </div>
            {
              <div style={{ display: this.state.activeStep === 1 ? 'block' : 'none' }}>
                <div className='form-group'>
                  <label htmlFor='name'>Name<span className='text-danger'>*</span></label>
                  <Input
                    type='text'
                    name='name'
                    initValue={this.textInputs && this.textInputs.name && this.textInputs.name.value}
                    onChange={e => this.onTextInputChange('name', e)}
                    validators={[Vali.required]}
                  />
                </div>
                <div className='form-group'>
                  <label htmlFor='description'>Description</label>
                  <TextArea
                    name='description'
                    rows={5}
                    initValue={this.textInputs && this.textInputs.name && this.textInputs.description.value}
                    onChange={e => this.onTextInputChange('description', e)}
                  />
                </div>
                {
                  this.props.maintenanceTaskDetail &&
                  this.renderRepeatInfo(this.props.maintenanceTaskDetail)
                }
              </div>
            }
            {
              <div className='step'>
                <div
                  className={`step-number ${this.state.activeStep === 2 ? 'active' : ''}`}
                  onClick={() => this.setState({activeStep: 2})}>2</div>
                <span className='step-header'>Apply to the whole project or limit to some lots </span>
              </div>
            }
            {
              this.state.activeStep === 1 &&
              <div style={{marginLeft: 3}}>Select lots to apply this maintenance task (Optional)</div>
            }
            {
              this.state.activeStep === 2 &&
              <React.Fragment>
                <CheckBoxSingle
                  name='apply_all'
                  ref='isAppliedAll'
                  className='checkbox-default'
                  style={{margin: 0, bottom: 10, textOverflow: 'ellipsis', overflow: 'hidden'}}
                  label='Apply to this maintenance schedule to the whole project'
                  checked={this.state.applyToAllLot}
                  onChecked={(e,d,s) => this.onClickApplyAllCheckbox(s.checked)}
                />
                {
                  this.state.activeStep === 2 &&
                  <div className='row'>
                    <div className='col-md-6'>
                      <div style={{margin: '10px 0'}}>
                        <b>Pick lots to apply this maintenance schedule</b>
                      </div>
                      <div className='input-group' style={{margin: '10px 0'}}>
                        <input
                          type='text'
                          className='form-control'
                          placeholder='Lot# / Street address'
                          value={this.state.searchText}
                          onChange={this.onChangeSearchTxt}
                        />
                        <span className='input-group-btn'>
                          <button
                            type='button'
                            className='btn btn-secondary'
                            style={{ padding: '4px 10px', fontSize: 16, backgroundColor: '#ececec', border: '0.5px solid #d8d8d8', height: 40 }}>
                            <span className='fa fa-search' />
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                }
                {this.renderLotList()}
              </React.Fragment>
            }
          </div>
          {
            <div style={{marginTop: 20}}>
              <div className='col-md-12 col-xs-12'>
                <span className='btn btn-siteone-default' onClick={this.props.onCancel}>Cancel</span>
                <button
                  type='submit'
                  className='btn btn-primary btn-siteone'
                  disabled={this.state.hasError ? 'disabled' : null}
                  onClick={this.onClickSaveButton}>
                    Save
                </button>
              </div>
            </div>
          }
        </React.Fragment>
      );
    }
}

const mapStateToProps = (state) => {
  return {
    maintenanceTaskDetail: state.ProjectStore.MaintenanceTaskDetail
  };
};

export default connect(mapStateToProps)(GeneralMaintenanceTaskView);



// WEBPACK FOOTER //
// ./src/Projects/Components/Maintenance/task-general-view.js